import { Form, Resource, BaseModel, Entry, EntryTypes, TableButton, CardMode, TableMode } from '@ngx-resource-toolkit/core';
import { ResponsableModel } from '../../responsable/models/responsable.model';
import { environment } from '../../../../environments/environment';
import { EleveModel } from '../../../eleve/models/eleve.model';
import { FactureModel } from '../../facture/models/facture.model';
import { PaiementModel } from '../../paiement/models/paiement.model';
import { LeaResource } from '../../resource/lea.resource';
import { Validators } from '@angular/forms';
import { ValidationsHelper } from '../../helpers/validations.helper';
import { FamilleReducer, FamilleEpics } from './famille.store';
import { FormGroup } from '@angular/forms';
import { trancheQFFetchOptions } from '../../resource/select-options';
import { TABLE } from '../../../app.constantes';
import { PhonePipe } from '../../pipes/phone.pipe';
import * as moment from 'moment';

import { HttpClient } from '@angular/common/http';

const listCodePostauxVille = [
    { cp: "92210", ville: "Saint-Cloud" },
    { cp: "92100", ville: "Boulogne-Billancourt" },
    { cp: "92380", ville: "Garches" },
    { cp: "92150", ville: "Suresnes" },
    { cp: "78000", ville: "Versailles" },
    { cp: "78150", ville: "Le Chesnay-Rocquencourt" },
    { cp: "78140", ville: "Vélizy-Villacoublay" },
    { cp: "78000", ville: "Versailles" },
]

const adresseOnChange = (value: Adresse, form: any) => {
    const codePostal: string = form.value['codePostal'];

    if (codePostal && codePostal.trim().length >= 4 && !value.ville) {
        // Rechercher la ville : voir pourmettre en dur certains codes postaux en attendant de réécrire...
        let listcpville = listCodePostauxVille.filter(x => { return x.cp == codePostal }); //x.cp.startsWith(codePostal)
        // console.log({ listcpville})
        if (listcpville.length == 1) {
            // console.log({ ville: listcpville[0].ville })
            form.patchValue({ ville: listcpville[0].ville }, { emitEvent: false });
        }
        //ServiceAutoCompleter.searchVilleByCriteria(codePostal)
    }
};

@Form({
    'create': {
        onChanges: adresseOnChange,
    },
    'famille': {
        onChanges: adresseOnChange,
    },
})
export class Adresse extends BaseModel {

    @Entry({
        base: {
            hidden: true,
        },
        'create': {},
        'famille': {},
    })
    id: number;

    @Entry({
        base: {
            type: EntryTypes.TEXT,
            css: {
                group: 'col-lg-3 col-md-6 col-sm-6 col-xs-12',
            },
            label: 'Adresse'
        },
        'create': {},
        'famille': {},
    })
    adresse1: string;

    @Entry({
        base: {
            type: EntryTypes.TEXT,
            css: {
                group: 'col-lg-3 col-md-6 col-sm-6 col-xs-12',
            },
            label: 'Complément'
        },
        'create': {},
        'famille': {},
    })
    adresse2: string;

    @Entry({
        base: {
            type: EntryTypes.NUMBER,
            label: 'Code postal',
            css: {
                group: 'col-lg-3 col-md-6 col-sm-6 col-xs-12',
            },
        },
        'create': {},
        'famille': {},
    })
    codePostal: number;

    @Entry({
        base: {
            type: EntryTypes.TEXT,
            label: 'Ville',
            css: {
                group: 'col-lg-3 col-md-6 col-sm-6 col-xs-12',
            },
        },
        'create': {},
        'famille': {},
    })
    ville: string;
    libellePersonne: string;
    responsable: ResponsableModel;
    familleNom: string;
    isComplet: boolean;
    isDeleted: boolean;
    isModified: boolean;

    constructor(data?) {
        super();
        if (!data) {
            data = {};
        }

        Object.assign(this, data);
    }
}

@Resource({
    modes: {
        'default': {
            url: environment.proxyUrl + '/famille',
            methods: LeaResource.methods,
        }
    },
    store: {
        namespace: 'famille',
        reducer: FamilleReducer,
        epics: FamilleEpics,
    }
})
@Form({
    'famille': {

    }, // Used for familly edition
    'create': {
        onChanges: (value: FamilleModel, form: any) => {
            const nom: string = form.value['nom'];
            if (nom) {
                form.patchValue({nom: nom.toUpperCase()},  {emitEvent: false});
            }
        }
    },
    'table': {},
})
export class FamilleModel extends BaseModel {

    @Entry({
        'famille': {
            hidden: true
        },
        'create': {
            hidden: true
        },
        'table': {
            label: 'N°',
            // width: 50,
            minWidth: TABLE.MIN_WIDTH.ID,
            // maxWidth: 80,
            // flexGrow: 1,
            colOrder: 1,
            // summaryFunc: (cells) => `${cells.length} total`,
        }
    })
    id: number;

    @Entry({
        base: {
            type: EntryTypes.TEXT,
            label: 'Nom',
            css: {
                group: 'col-lg-3 col-md-6 col-sm-6',
            },
            validators: [Validators.required],
            validatorsMsgs: {
                'required': 'Le nom est obligatoire'
            },
        },
        'famille': {},
        'create': {
        },
        'table': {
            label: 'Nom',
            minWidth: TABLE.MIN_WIDTH.NOM_PRENOM,
            colOrder: 2,
        }
    })
    nom: string;

    @Entry({
        base: {
            type: EntryTypes.SELECT,
            label: 'Tranche QF',
            css: {
                group: 'col-lg-3 col-md-6 col-sm-6 col-xs-12',
                // input: 'col-xs-12'
            },
            fetchOptions: trancheQFFetchOptions,
        },
        'create': {
            fetchOptions: null, // En création on utilise registerEntryDynamicProperty dans ngOnInit
        },
        'famille': {
            // fetchOptions: trancheQFFetchOptions, // En création on utilise registerEntryDynamicProperty dans ngOnInit
        },
    })
    trancheQuotientFamilial: string;
    libelleTrancheQuotientFamilial: string;

    @Entry({
        base: {
            type: EntryTypes.DATE,
            format: 'YYYY-MM-DD', // Format BDD (back)
            placeholder: 'JJ/MM/AAAA',
            formatDisplay: 'DD/MM/YYYY', // Format affichage IHM
            css: {
                group: 'col-lg-3 col-md-6 col-sm-6 col-xs-12',
                // input: 'col-xs-12'
            },
            label: 'Date d\'entrée',
            default: null,
        },
        'create': {
            default: moment(new Date()).format('YYYY-MM-DD'),
        },
        'famille': {},
    })
    dateEntree: Date;

    @Entry({
        base: {
            type: EntryTypes.DATE,
            format: 'YYYY-MM-DD',
            placeholder: 'JJ/MM/AAAA',
            formatDisplay: 'DD/MM/YYYY',
            css: {
                group: 'col-lg-3 col-md-6 col-sm-6 col-xs-12',
                // input: 'col-xs-12'
            },
            label: 'Date de sortie',
        },
        'create': {},
        'famille': {},
    })
    dateFin: string;

    @Entry({
        base: {
            type: EntryTypes.CHECKBOX,
            css: {
                group: 'col-lg-12 col-sm-12 col-xs-12',
            },
            options: [{
                value: true,
                label: 'Famille nombreuse',
            }]
        },
        'create': {},
        'famille': {},
    })
    isFamilleNombreuse: boolean;

    @Entry({
        'table': {
            label: 'Responsable',
            minWidth: TABLE.MIN_WIDTH.NOM_PRENOM * 2,
            colOrder: 3,
        }
    })
    responsable: string;

    @Entry({
        'table': {
            label: 'Téléphones',
            flexGrow: 3,
            minWidth: TABLE.MIN_WIDTH.TEL * 2,
            colOrder: 4,
        }
    })
    telephones: string;

    @Entry({
        base: {
            nested: true,
            css: {
                group: 'col-xs-12'
            }
        },
        'create': {},
        'famille': {},
    })
    adresse: Adresse;

    @Entry({
        base: {
            type: EntryTypes.CHECKBOX,
            css: {
                group: 'col-lg-4 col-xs-4',
            },
            options: [{
                value: true,
                label: 'Local',
            }]
        },
        'create': {},
        'famille': {},
    })
    isLocal: boolean;

    @Entry({
        base: {
            type: EntryTypes.CHECKBOX,
            css: {
                group: 'col-lg-4 col-xs-4',
            },
            options: [{
                value: true,
                label: 'Local élargi',
            }],
            hidden: true,
        },
        'create': {},
        'famille': {},
    })
    isLocalElargi: boolean;

    @Entry({
        base: {
            type: EntryTypes.CHECKBOX,
            css: {
                group: 'col-lg-4 col-xs-4',
            },
            options: [{
                value: true,
                label: 'Forcer calcul local',
            }]
        },
        'create': {},
        'famille': {},
    })
    isForceLocal: boolean;

    @Entry({
        base: {
            type: EntryTypes.TEXTAREA,
            css: {
                group: 'col-lg-12 col-xs-12',
            },
            label: 'Saisie libre'
        },
        'create': {},
        'famille': {},
    })
    saisieLibre: string;

    @Entry({
        base: {
            type: EntryTypes.CARDS,
            mode: CardMode.EDIT,
            model: ResponsableModel,
            addLabel: 'Ajouter Responsable',
            title: 'Responsable',
            css: {
                box: 'panel panel-default col-xs-6 col-md-4 col-lg-3',
            },
            // nested: true,
            multiple: true,
            validators: [ValidationsHelper.minLengthArray(1)],
            validatorsMsgs: {
                'required': 'Veuillez ajouter au moins un responsable'
            }
        },
        'create': {},
        'famille': {
            // nested: true,
        },
    })
    responsables: ResponsableModel[];

  /*  @Entry({
        base: {
            type: EntryTypes.TABLE,
            mode: TableMode.EDITABLE,
            model: ResponsableModel,
            addLabel: 'Ajouter Responsable',
            title: 'Responsable',
            css: {
                box: 'panel panel-default col-xs-6 col-md-4 col-lg-3',
            },
            // nested: true,
            multiple: true,
            validators: [ValidationsHelper.minLengthArray(1)],
            validatorsMsgs: {
                'required': 'Veuillez ajouter au moins un responsable'
            }
        },
        'create': {},
        'famille': {},
    })
    responsables: ResponsableModel[];*/

    @Entry({
        base: {
            type: EntryTypes.CARDS,
            mode: CardMode.EDIT,
            model: EleveModel,
            addLabel: 'Ajouter Elève',
            title: 'Elève',
            css: {
                box: 'panel panel-default col-xs-12 col-sm-6 col-md-4 col-lg-3',
            },
            multiple: true,
        },
        'create': {},
        'famille': {},
    })
    eleves: EleveModel[];

    total_facture: number;
    total_paiements: number;

    @Entry({
        'table': {
            label: 'Solde',
            minWidth: TABLE.MIN_WIDTH.PAIEMENT_MONTANT,
            hidden: true,
            colOrder: 5,
        }
    })
    solde: number;

    quotientFamilial: string;

    @Entry({
        base: {
            type: EntryTypes.TEXT,
            label: 'Année',
            css: {
                group: 'col-lg-3 col-md-6 col-sm-6',
            },
            minWidth: TABLE.MIN_WIDTH.ANNEE_SCOLAIRE,
            hidden: true,
        },
        'famille': {},
        'create': {},
        'table': {}
    })
    anneeScolaire: string;

    isComplet: boolean;
    isDeleted: boolean;
    isModified: boolean;
    anneeScolaireDebut: string;
    anneeScolaireFin: string;

    paiements: PaiementModel[];
    factures: FactureModel[];

    constructor(data) {
        super();
        this.id = data.id;
        this.nom = data.nom;
        this.adresse = data.adresse;
        this.isLocal = data.isLocal;
        this.isLocalElargi = data.isLocalElargi;
        this.saisieLibre = data.saisieLibre;
        this.dateEntree = data.dateEntree;
        this.dateFin = data.dateFin;
        this.total_facture = data.total_facture;
        this.total_paiements = data.total_paiements;
        this.isFamilleNombreuse = data.isFamilleNombreuse;
        this.quotientFamilial = data.quotientFamilial;
        this.trancheQuotientFamilial = data.trancheQuotientFamilial;
        // this.anneeScolaire = data.anneeScolaire;

        Object.assign(this, data);

        if (data && data.responsables instanceof Array) {
            this.responsables = [];
            data.responsables.forEach((responsable) => {
                this.responsables.push(new ResponsableModel(responsable));
            });
        }

        if (data && data.adresse) {
            this.adresse = new Adresse(data.adresse);
        }

        if (data && data.responsables && data.responsables[0]) {
            this.responsable = ((data.responsables[0].nom === null) ? '' : (data.responsables[0].nom + ' '))
                + ((data.responsables[0].prenom === null) ? '' : data.responsables[0].prenom);
            this.telephones =
                ((data.responsables[0].telephoneDomicile === null) ? '' : new PhonePipe().transform(data.responsables[0].telephoneDomicile)
                + ' / ') +
                ((data.responsables[0].telephoneMobile === null) ? '' : new PhonePipe().transform(data.responsables[0].telephoneMobile));
        }

        if (data.total_facture) {
            const total_paiements = data.total_paiements ? data.total_paiements : 0;
            this.solde = Math.round((data.total_facture - total_paiements) * 100) / 100;
        }

        this.setEleves(data.eleves);
        this.setFactures(data.factures);
        this.setPaiements(data.paiements);

        /*if (!this.id) {
            this.anneeScolaire = this.settings.getUserSetting('anneeScolaire');
        }*/
    }

    setFactures(factures) {
        if (factures instanceof Array) {
            this.factures = [];
            factures.forEach((facture) => {
                this.factures.push(new FactureModel(facture));
            });
        }
    }

    setPaiements(paiements) {
        if (paiements instanceof Array) {
            this.paiements = [];
            paiements.forEach((paiement) => {
                this.paiements.push(new PaiementModel({...paiement, familleId: this.id}));
            });
        }
    }

    setEleves(eleves) {
        if (eleves instanceof Array) {
            this.eleves = [];
            eleves.forEach((eleve) => {
                this.eleves.push(new EleveModel(eleve));
            });
        }
    }
}



// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/famille/models/famille.model.ts